<template>
	<div class="inner_content">
		<div class="header">
			<el-button type="primary" size="small" @click="handle(1, 0)"
				>添加报表</el-button
			>
			<div class="box flex">
				<div class="title">数据纬度：</div>
				<el-select
					v-model="value"
					placeholder="请选择"
					size="small"
					class="fixedwidth"
				>
					<el-option
						v-for="(item, index) in options"
						:key="index"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>
			<div class="box flex">
				<div class="title">时间周期：</div>
				<el-select
					v-model="value"
					placeholder="请选择"
					size="small"
					class="fixedwidth"
				>
					<el-option
						v-for="(item, index) in periodData"
						:key="index"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>
			<!-- <div class="box flex">
        <div class="title">报表日期：</div>
        <el-date-picker
          v-model="value1"
          size="small"
          class=""
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div> -->
			<div class="box flex">
				<div class="title"></div>
				<el-button size="small" type="primary" placeholder="请输入报表名称"
					>查询</el-button
				>
			</div>
		</div>
		<el-table
			:data="tableData"
			size="small"
			:header-cell-style="setHeader"
			height="100%"
		>
			<el-table-column
				prop="name"
				label="报表名称"
				width="140"
			></el-table-column>
			<el-table-column prop="bus" label="数据粒度"></el-table-column>
			<el-table-column prop="bus" label="数据维度"></el-table-column>
			<el-table-column prop="bus" label="时间周期"></el-table-column>
			<el-table-column prop="title" label="报表更新时间">
				<template slot-scope="scope">
					{{ scope.row.start_time }}
					<span>至</span>
					{{ scope.row.end_time }}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200">
				<!-- <template slot-scope="scope"> -->
					<!-- <el-button size="mini" @click="handle(1, scope.row.id)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handle(0, scope.row.id)"
            >删除</el-button
          > -->
				<!-- </template> -->
			</el-table-column>
		</el-table>
		<el-pagination
			@current-change="handleCurrentChange"
			layout="total, prev, pager, next, jumper"
			:total="total_num"
		>
		</el-pagination>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { listConsumption, delConsumption } from "@/api/market";
export default {
	inject: ["reload"],
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			periodData: [
				{
					label: "全部",
					value: "0",
				},
				{
					label: "分小时",
					value: "0",
				},
				{
					label: "自然日",
					value: "0",
				},
				{
					label: "自然周",
					value: "0",
				},
				{
					label: "自然月",
					value: "0",
				},
			],
			page: "0",
			total_num: 0,
			tableData: [],
			form: {
				value: true,
				name: "",
				region: "",
			},
			formLabelWidth: "120px",
			dialogFormVisible: false,
			options: [
				{
					value: "0",
					label: "全部状态",
				},
			],
			value1: "",
			value: "",
			headerStyle: {
				background: "rgba(250,250,250,1)",
				color: "#000000",
			},
		};
	},
	mounted() {
		// this.getData();
	},
	methods: {
		getData() {
			let data = {
				app_id: this.app_id,
				token: this.token,
				page: this.page,
			};
			listConsumption(data).then((res) => {
				if (res.code == 200) {
					this.tableData = res.result;
					this.tableData.forEach((item) => {
						item.bus = item.bus_status ? "" : "油品";
						// item.use_status = item.bus_status ? "" : "油品";
						switch (item.use_status) {
							case 0:
								item.users = "每次消费";
								break;
							case 1:
								item.users = "仅首次消费";
								break;
							case 2:
								item.users = "第二次及之后的消费";
								break;
						}
					});
					this.total_num = res.total_num;
				}
				console.log("数据", data);
			});
		},
		handleCurrentChange(val) {
			this.page = val;
			// this.productLists();
		},
		// 设置表头颜色
		setHeader({ rowIndex }) {
			if (rowIndex === 0) {
				return this.headerStyle;
			} else {
				return "";
			}
		},
		handle(jude, id) {
			if (jude) {
				this.$router.push({
					path: `set`,
					query: {
						status: id,
					},
				});
			} else {
				delConsumption({
					app_id: this.app_id,
					token: this.token,
					id: id,
				}).then((res) => {
					if (res.code == 200) {
						this.$message.success("删除成功");
						this.reload();
					} else {
						this.$message.warning(res.msg);
					}
				});
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.inner_content {
	background: #fff;
	padding: 0 24px;
	height: 100%;
	display: flex;
	flex-direction: column;
	.header {
		width: 100%;
		height: 102px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		// margin-bottom: 20px;
		.box {
			width: 330px;
			.title {
				min-width: 100px;
				text-align: right;
			}
			.fixedwidth {
				width: 180px;
				display: flex;
				justify-content: space-between;
			}
		}
	}
	.el-table {
		flex: 1;
		overflow-y: auto;
	}
	.el-pagination {
		height: 60px;
		padding-top: 16px;
	}
}
// 通用样式
.flex {
	display: flex;
	align-items: center;
	padding: 10px 0px;
}
</style>
